import { JetView } from 'webix-jet';

/**
 * Class representing a view for filtering withdrawal requests.
 * @extends JetView
 */
export default class FilterWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        // Left section containing input fields
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for account ID
                            name: 'Id',
                            type: 'number',
                            label: _('ID Cuenta'), // Label for account ID
                            labelPosition: 'top',
                            placeholder: _('ID'), // Placeholder text
                        },
                        {
                            view: 'richselect', // Dropdown for acceptance type
                            name: 'AcceptanceType',
                            localId: 'bonusStates:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Label for acceptance type
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: '',
                            options: [
                                // Options for the dropdown
                                { id: '', value: _('Todos') },
                                { id: 'A', value: _('Activo') },
                                { id: 'I', value: _('Inactivo') },
                            ],
                        },
                    ],
                },
            ],
        };

        // Upper section containing the left section
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Buttons for clearing and consulting
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    width: 100,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form',
                    width: 110,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('bankAccountReport:filter', [
                            filterdata, // Trigger filter event with form data
                        ]);
                        $$('b5').collapse(); // Collapse the accordion
                    },
                },
            ],
        };

        // Additional buttons for a second form
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Clear button for second form
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').clear(); // Clears the second form
                    },
                },
                {
                    view: 'button', // Consult button for second form
                    value: _('Consultar'),
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get second form values
                        this.app.callEvent('bankAccountReport:filter', [
                            filterdata, // Trigger filter event with second form data
                        ]);
                        $$('filterPopup').hide(); // Hide the filter popup
                    },
                },
            ],
        };

        // Accordion section containing filters
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Contains upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Scrollable section for filters
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Contains upper section
            },
        };

        // Popup window for filters
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2', // ID for the second form
                type: 'clean',
                rows: [accordion_section3, buttons2], // Contains scrollable section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for the form
                },
            },
        });

        // Main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion section if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the main form
            },
        };
    }
}

// FILE DOCUMENTED
